// extracted by mini-css-extract-plugin
module.exports = {"GeekBoy":"GeekBoy_GeekBoy__3OhjG","pulse":"GeekBoy_pulse__2oAaT","hidden":"GeekBoy_hidden__21XXo","fadeOut":"GeekBoy_fadeOut__oJHkn"};